const defaultFontFamily = "WorkSans";

const small = `
font-family: ${defaultFontFamily};
font-style: normal;
font-weight: normal;
font-size: 1.15rem;
line-height: 150%;
`;

const fonts = { small };

export default fonts;
